import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import { setProgressBarColor } from '../utils';

const NodeIndicators = ({ value, label, metric, icon = false }) => {
  const currentMetricThresholds = useSelector((state) => state?.fuse?.dashboard?.metricThresholds);
  // const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);
  const [cardBackgroundColor, setCardBackgroundColor] = useState('#E5E4E2');
  // const [metricStatus, setMetricStatu]

  useEffect(() => {
    const valueNumber = Number(value);
    if (value && !Number.isNaN(valueNumber) && valueNumber >= 0) {
      const [iconColor, cardColor] = setProgressBarColor(Number(value), metric, currentMetricThresholds);
      setCardBackgroundColor(cardColor);
    } else {
      setCardBackgroundColor('#E5E4E2');
    }
  }, [value, metric, currentMetricThresholds]);

  const StatusIcon = () => {
    const [iconColor, cardColor] = setProgressBarColor(Number(value), metric, currentMetricThresholds);
    if (iconColor === 'success') {
      return <CheckCircleOutlineIcon fontSize="medium" color="success" />;
    }
    if (iconColor === 'error') {
      return <ErrorIcon fontSize="medium" color="error" />;
    }
    if (iconColor === 'warning') {
      return <WarningAmberIcon fontSize="medium" color="warning" />;
    }
    return <InfoIcon fontSize="medium" />;
  };

  const valueLabel = () => {
    const valueNumber = Number(value);
    if (value && !Number.isNaN(valueNumber) && valueNumber >= 0) {
      return Number(value || '0').toFixed(2);
    }
    return 'Sin Datos';
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '10px',
        width: '70%',
        backgroundColor: cardBackgroundColor,
        justifySelf: 'center',
        height: '80px',
        marginBottom: '10px',
        textAlign: 'center',
      }}
    >
      {/* {icon && StatusIcon()} */}
      <h2 style={{ color: cardBackgroundColor === '#E5E4E2' ? '#000' : '#FFF' }}>{valueLabel()}</h2>
      <h3 style={{ color: cardBackgroundColor === '#E5E4E2' ? '#000' : '#FFF' }}>{label}</h3>
    </div>
  );
};

export default NodeIndicators;
